/**
 * Unread badge: the inbox count, plus one while the push opt-in is still
 * sitting in the inbox.
 */

import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { api } from "./api.ts";
import {
  isPushOptInTrashed,
  syncPushOptInVisibility,
  watchPushOptInVisibility,
} from "./push-optin.ts";

export { EDM_PUSH_EVENT } from "./push-optin.ts";

export function useUnreadCount() {
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey: ["notifications", "unread"],
    queryFn: () => api.get<{ count: number }>("/notifications/unread"),
  });
  const [extra, setExtra] = useState(0);

  useEffect(() => {
    return watchPushOptInVisibility(() => {
      void queryClient.invalidateQueries({ queryKey: ["notifications", "unread"] });
      const optIn =
        typeof Notification !== "undefined" && !syncPushOptInVisibility() && !isPushOptInTrashed();
      setExtra(optIn ? 1 : 0);
    });
  }, [queryClient]);

  return (query.data?.count ?? 0) + extra;
}
